{
  "language_switcher": {
    "label": "Language"
  },
  "language_banner": {
    "text": "This page is also available in English.",
    "cta": "View in English",
    "dismiss": "Dismiss"
  },
  "open_in_app_banner": {
    "title": "Open in the TOBY app",
    "open": "Open",
    "install_title": "The TOBY app for Android",
    "install": "Install",
    "dismiss": "Dismiss"
  },
  "marketing_consent_banner": {
    "title": "Would you like tips for your website and product news by email now and then?",
    "reask_title": "Your website is live! Would you like tips for getting more customers from it by email now and then?",
    "accept": "Yes, please",
    "dismiss": "No thanks"
  },
  "reviewer_banner": {
    "title": "Review access for {outlet}, until {date}.",
    "questions": "Questions?",
    "keep": "Keep this site"
  },
  "user_menu": {
    "settings": "User settings",
    "subscription": "Subscription",
    "log_out": "Log out",
    "language": "Language"
  },
  "site_menu": {
    "visit_site": "View website",
    "analytics": "Analytics",
    "support": "Support",
    "elements": "What you can add"
  },
  "mobile_nav": {
    "label": "Main navigation",
    "edit": "Edit",
    "edit_site": "Edit site",
    "messages": "Messages",
    "library": "Library",
    "newsletter": "Newsletter",
    "settings": "Settings",
    "more": "More",
    "expand": "Expand menu",
    "collapse": "Collapse menu",
    "unpublished_changes": "Unpublished changes",
    "new_messages": "{count, plural, one {# new message} other {# new messages}}",
    "sites_title": "Your websites",
    "sites_subtitle": "Tabs and settings switch along with it.",
    "site_published": "Live",
    "site_draft": "Draft",
    "done": "Done",
    "statistics_group": "Statistics",
    "website_group": "Website",
    "account_group": "Account"
  },
  "support": {
    "title": "Support",
    "description": "Stuck, or something not working? Write or call us — we're happy to help.",
    "email_label": "Email",
    "phone_label": "Phone"
  },
  "contact": {
    "intro": "Have a question, or need a hand with your website? Call or write — we're happy to help."
  },
  "press": {
    "intro": "Our logo for articles, social-media profiles and anywhere else you mention TOBY. The PNG files have a transparent background and rounded corners; the SVG scales to any size.",
    "logo_red": "Red",
    "logo_white": "White — for dark or colourful backgrounds",
    "usage_heading": "Using the logo",
    "usage_name": "Always write the name in capitals: TOBY.",
    "usage_unchanged": "Please don't change the logo's colours, proportions or lettering.",
    "colour_heading": "Brand red",
    "colour_screen": "On screen",
    "colour_print": "In print",
    "contact": "Questions from the press? Write to {email}."
  },
  "whats_new": {
    "title": "News",
    "description": "New features and improvements in TOBY, newest first.",
    "empty": "No news yet — the first update is on its way."
  },
  "voice": {
    "listening": "TOBY is listening",
    "speaking": "TOBY is speaking",
    "paused": "TOBY is muted",
    "connecting": "Connecting…",
    "connection_lost": "Voice chat lost its connection. You can keep editing by typing.",
    "unavailable": "Voice chat isn’t available right now. Try again in a moment, or keep editing by typing.",
    "mode_changed": "Your voice setting changed. Open this page again to keep talking to TOBY.",
    "mic_blocked": "Microphone blocked",
    "mic_blocked_how": "TOBY can’t hear you. Switch the microphone on in your settings, then tap the microphone again.",
    "time_almost_up": "Voice time is almost used up. You can keep editing by typing.",
    "time_used_up": "Voice time is used up for now. You can keep editing by typing.",
    "mute_aria": "Mute",
    "unmute_aria": "Resume",
    "thinking": "TOBY is working…",
    "record_aria": "Record a voice note",
    "stop_aria": "Stop and send",
    "discard_aria": "Discard recording",
    "nothing_heard": "TOBY didn’t hear anything. Tap the microphone and try again."
  },
  "composer": {
    "placeholder": "TOBY is ready",
    "hint_say": "Tell TOBY",
    "hint_type": "Write to TOBY",
    "hint_show": "Show TOBY",
    "type_placeholder": "What should change?",
    "camera_aria": "Take a photo or attach images, PDFs, Word or Excel documents",
    "mic_aria": "Start voice mode",
    "keyboard_aria": "Type a message",
    "disclaimer": "TOBY can make mistakes. Verify your website changes.",
    "disclaimer_ok": "OK"
  },
  "publish": {
    "publish": "Publish",
    "view": "View site",
    "publish_aria": "Publish changes",
    "view_aria": "View published site"
  },
  "newsletter_authoring": {
    "send_test": "Send test",
    "test_sending": "Sending…",
    "test_sent": "Test sent ✓",
    "test_failed": "Couldn’t send",
    "send": "Send",
    "subject_label": "Subject",
    "subject_placeholder": "What shows in the inbox",
    "sent_notice": "Read-only — sent on {date}",
    "send_confirm_title": "Send to {count, plural, one {1 subscriber} other {# subscribers}}?",
    "send_confirm_description": "Your newsletter goes out by email to everyone on your list. This can't be undone.",
    "send_confirm_confirm": "Send now",
    "send_confirm_cancel": "Cancel",
    "send_sending": "Sending…",
    "send_done": "Sent ✓",
    "send_no_recipients_title": "No subscribers yet",
    "send_error_no_recipients": "You don't have any subscribers yet.",
    "send_error_empty": "The newsletter is still empty — add some content first.",
    "send_error_paused": "Sending is paused for this website. Please contact support.",
    "send_error_review_preview": "Sending to subscribers is switched off in this preview. Use “Send test” to see it in your own inbox.",
    "send_error_generic": "Couldn't send — please try again.",
    "sending_notice": "Sending… your newsletter is going out to your subscribers."
  },
  "preview": {
    "nav_back_aria": "Back",
    "nav_forward_aria": "Forward",
    "nav_home_aria": "Homepage",
    "viewport_desktop_aria": "Desktop view",
    "viewport_mobile_aria": "Mobile view",
    "translated_banner_note": "Heads up — TOBY makes changes in your main language, {primary}. This {current} version updates when you publish.",
    "view_primary_cta": "View in {primary}"
  },
  "brandSlogan": "Your website manager",
  "chat": {
    "getting_started": {
      "title_lead": "Let's build your",
      "title_accent": "website",
      "photo_title": "Take a photo",
      "chips": {
        "business_card": "Business card",
        "menu": "Menu",
        "price_list": "Price list",
        "storefront": "Storefront",
        "team": "Team"
      },
      "take_photo": "Take photo",
      "or": "or",
      "tell_title": "Tell me about your business",
      "tell_description": "Your business name, what you do, and where you're based.",
      "tell_input_aria": "Type or speak your answer",
      "hint": "Your finished website will appear right here as you go."
    },
    "voice_opt_in": {
      "title_lead": "Talk to your",
      "title_accent": "website",
      "body": "Tell {brand} what your business does and what should change. {brand} listens, builds and edits as you speak.",
      "start": "Start talking",
      "reassurance": "We'll ask for microphone access next. You can always type instead."
    },
    "collapse_history_aria": "Close chat",
    "drop_files_here": "Drop images, PDFs, Word or Excel files here",
    "drop_unsupported": "Only images, PDFs, Word and Excel documents can be added.",
    "text_mode_hint": "Talk to {brand}. Press Enter to send, Shift+Enter for a newline. Attach images, PDFs, Word or Excel documents with the camera button, or click the mic to dictate and hear the reply.",
    "tools": {
      "rejected": "Change not saved",
      "running": {
        "list_pages": "Looking through your pages",
        "get_page": "Reading a page",
        "view_page": "Opening a page",
        "current_page": "Checking this page",
        "check_link": "Checking the link",
        "update_page": "Updating your page",
        "delete_page": "Removing a page",
        "bulk_update": "Updating your website",
        "get_site_meta": "Checking your site settings",
        "update_site_meta": "Updating your site settings",
        "set_languages": "Updating your languages",
        "publish_site": "Publishing your website",
        "list_uploads": "Looking through your images",
        "get_upload": "Checking an image",
        "create_upload": "Adding your image",
        "delete_upload": "Removing an image",
        "rotate_image": "Rotating your image",
        "extract_logo": "Finding your logo",
        "extract_brand_logos": "Cutting out the brand logos",
        "remove_logo": "Removing your logo",
        "import_pdf": "Building your site from the PDF",
        "analyze_pdf": "Reading your PDF",
        "get_newsletter_subscriber_count": "Checking your newsletter sign-ups",
        "get_datetime": "Checking the date",
        "restore_version": "Restoring an earlier version",
        "claim_subdomain": "Setting up your web address",
        "open_newsletter": "Opening your newsletter",
        "open_referral_page": "Opening your referral page",
        "remember": "Making a note",
        "forget": "Removing a note",
        "resolve_nudge": "Updating your suggestions",
        "newsletter_update_body": "Updating your newsletter",
        "set_newsletter_meta": "Updating your newsletter settings",
        "claim_domain": "Checking domains"
      },
      "done": {
        "list_pages": "Reviewed your pages",
        "get_page": "Read the page",
        "view_page": "Opened the page",
        "current_page": "Checked this page",
        "check_link": "Checked the link",
        "update_page": "Page updated",
        "delete_page": "Page removed",
        "bulk_update": "Website updated",
        "get_site_meta": "Checked your site settings",
        "update_site_meta": "Site settings updated",
        "set_languages": "Languages updated",
        "publish_site": "Website published",
        "list_uploads": "Reviewed your images",
        "get_upload": "Checked the image",
        "create_upload": "Image added",
        "delete_upload": "Image removed",
        "rotate_image": "Image rotated",
        "extract_logo": "Logo added",
        "extract_brand_logos": "Brand logos ready",
        "remove_logo": "Logo removed",
        "import_pdf": "Site built from your PDF",
        "analyze_pdf": "Finished reading your PDF",
        "get_newsletter_subscriber_count": "Checked your newsletter sign-ups",
        "get_datetime": "Checked the date",
        "restore_version": "Version restored",
        "claim_subdomain": "Web address ready",
        "open_newsletter": "Opened your newsletter",
        "open_referral_page": "Opened your referral page",
        "remember": "Noted",
        "forget": "Note removed",
        "resolve_nudge": "Suggestion handled",
        "newsletter_update_body": "Newsletter updated",
        "set_newsletter_meta": "Newsletter settings updated",
        "claim_domain": "Domain check done"
      },
      "progress": {
        "import_pdf": "Adding photo {current} of {total}…",
        "analyze_pdf": "Reading your PDF…"
      }
    },
    "uploads": {
      "processing": "Adding your photos… ({done} of {total})",
      "uploading": "Uploading…",
      "analyzing": "Analyzing…",
      "analyzing_video": "Watching your video…"
    },
    "thinking": "{brand} is thinking…",
    "claim_domain_cta": "Your own domain is included — claim it now",
    "domain_claim_prompt": "I'd like to claim my included domain.",
    "domain_picker_pick_title": "Pick a domain",
    "domain_picker_pick_subtitle": "Choose one of these available options — it's included in your plan.",
    "domain_included_badge": "Included in your plan",
    "contact_form_hint": "Confirm your contact info for the domain registry. Registries require accurate ownership info on every domain.",
    "contact_saving": "Saving…",
    "contact_back": "Back",
    "contact_continue": "Continue",
    "contact_step_title": "Contact details for {name}",
    "contact_incomplete": "Please fill in every required field.",
    "contact_save_failed": "Could not save — please try again.",
    "contact_name": "Full name",
    "contact_registrant_kind": "Who will own the domain?",
    "contact_registrant_individual": "A private person",
    "contact_registrant_business": "A business",
    "contact_organization": "Business name",
    "contact_organization_hint": "Exactly as it's officially registered, including the legal form — for example Café Schnuckerl GmbH.",
    "contact_organization_required": "Please add the business name, or pick “A private person”.",
    "contact_email": "Email",
    "contact_phone": "Phone (e.g. +49 30 1234567)",
    "contact_street": "Street address",
    "contact_city": "City",
    "contact_state": "State / region",
    "contact_postal_code": "Postal code",
    "contact_country": "Country",
    "contact_country_placeholder": "Pick a country",
    "contact_personal_id_number": "ID or passport number",
    "contact_tax_id_number": "Tax or personal ID number",
    "contact_company_id_number": "Company registration number",
    "contact_vat_number": "VAT number",
    "contact_registry_hint": "The {tld} registry also requires this for the domain holder:",
    "registry_terms_notice": "By confirming, you also accept the {tld} registry's terms for this domain.",
    "register_final_title": "Confirm registration",
    "register_final_subtitle": "Last chance to back out — once you click Register, the domain is registered in your name.",
    "register_final_button": "Register {name}",
    "register_warning_final": "Domain registrations are final. This domain becomes your site's address; the old one will redirect to it.",
    "register_failed": "This could not be completed — please try again.",
    "transfer_title": "Transfer {name} to TOBY",
    "transfer_subtitle": "We'll take over managing and renewing your domain — it's included in your plan.",
    "transfer_auth_label": "Auth code (EPP code)",
    "transfer_auth_help": "You'll find it in your current provider's domain settings — sometimes called auth info or transfer code. Unlock the domain there first if it's locked.",
    "transfer_auth_missing": "Please enter the auth code from your current provider.",
    "transfer_dns_warning": "Keep everything at your current provider unchanged while the transfer runs — don't edit DNS settings or cancel the domain.",
    "transfer_duration_hint": "A .de transfer usually completes within minutes. A .com transfer can take 5–7 days — that's normal, and your domain keeps working meanwhile.",
    "transfer_final_title": "Confirm transfer",
    "transfer_final_subtitle": "We'll start the transfer now. Your site goes live on the domain as soon as it completes.",
    "transfer_final_button": "Transfer {name}",
    "domain_status": {
      "registered": "{name} is registered in your name! I'm connecting it to your website now — this usually takes a few more minutes.",
      "active": "🎉 Your website is now live on {name}. The old address redirects there automatically.",
      "failed": "The domain order for {name} didn't go through. Nothing was charged to you — let's try again or pick a different name.",
      "action_required": "The domain order for {name} needs a manual check on our side. We're on it and will follow up — nothing more to do for you right now."
    }
  },
  "sign_in": {
    "title": "Log in",
    "heading": "Log in to your account",
    "description": "Sign in or create your account in seconds",
    "continue_with_google": "Continue with Google",
    "continue_with_apple": "Continue with Apple",
    "last_used": "Last used",
    "or": "or",
    "email_placeholder": "you@email.com",
    "send_link": "Email me a sign-in link",
    "link_sent": "Check your inbox — click the link in it to continue.",
    "send_again": "Send again",
    "link_resent": "Sent again. Only the link in the newest email works.",
    "errors": {
      "email_failed": "Couldn't send the link. Please try again."
    },
    "plan": {
      "selected": "Your plan: {name}",
      "billed_month": "billed monthly",
      "billed_year": "billed yearly"
    },
    "description_native": "Sign in to your account"
  },
  "handoff": {
    "title": "Unlock your website",
    "your_website": "Your website",
    "link_invalid": "Link no longer valid",
    "description_ready": "Your website is ready. Sign in to take it over and keep it online.",
    "min_plan": "To put it online, you'll need the {plan} plan.",
    "description_invalid": "This link is no longer available — it may already have been claimed. Please ask for a new QR code in person.",
    "google_cta": "Unlock with Google",
    "apple_cta": "Unlock with Apple",
    "send_link": "Email me the link",
    "email_failed": "That didn't work. Please try again.",
    "link_sent_prefix": "We've sent a link to",
    "link_sent_suffix": ". Open it on this device to continue.",
    "pay_after_signin": "You only pay after you sign in."
  },
  "home": {
    "meta_description": "{brand} is the agent that builds, updates, and grows your small-business website — just by talking to it. No builder, no code. Live in 60 seconds.",
    "hero_headline": "You run your business.<br><em>{brand} runs your website.</em>",
    "hero_subcopy": "Your <strong>website agent</strong> — it builds, updates, and grows your business website through a conversation or a photo. No dashboards. No builders.",
    "hero_cta": "Get started",
    "sign_in": "Sign in",
    "go_to_site": "Go to your site",
    "pricing_heading": "Simple plans for small & medium sized businesses.",
    "contact_link": "Contact",
    "imprint_link": "Imprint",
    "privacy_link": "Privacy Policy",
    "terms_of_service_link": "Terms of Service",
    "data_processors_link": "Data Processors",
    "status_link": "Status",
    "made_in": "Made in Munich",
    "footer_support": "Support",
    "footer_product": "Product",
    "footer_legal": "Legal",
    "pricing_link": "Pricing",
    "docs_link": "Docs",
    "about_link": "About us",
    "press_link": "Press & logo",
    "pricing_title": "Pricing — TOBY",
    "report_link": "Report content",
    "demo_intro_headline": "Talk to your website",
    "demo_intro_label": "App Demo",
    "demo_video_title": "The whole demo, in one video",
    "demo_video_body": "The full demo as one file — save it, or send it to someone who needs a website.",
    "demo_video_download": "Download the video",
    "demo_share_instagram": "Instagram caption",
    "demo_share_copy_link": "Copy link",
    "demo_share_video_label": "Video",
    "demo_share_copy_video": "Copy video link",
    "demo_share_copied": "Copied",
    "demo_share_message": "See how {brand} builds and updates a website just by talking to it: {url}",
    "demo_share_instagram_caption": "A website you build by talking to it. That's {brand} — {handle} · {url}",
    "testimonial_quote_hauck": "“I’m absolutely thrilled. {brand} really works day to day: the changes I talk about in the shop, it makes in no time at all. Keeping up my old website with the old system was too complicated for me. {brand} even does what I tell it in Arabic and Turkish. {brand} even set up a newsletter for me that lets my customers know when there’s news. I just say: ‘{brand}, newsletter please: gluten-free tiramisu next Thursday and Friday.’ Done. Honestly, it’s wild”",
    "testimonial_quote_malcherzyk": "“With the {brand} app I can finally keep the website for my clothing and gear store up to date myself. At over 70, even I can do it!”",
    "testimonial_rating": "5 of 5 stars on Google Play",
    "testimonial_translated": "Translated from German",
    "cancel_link": "Cancel contract"
  },
  "landing": {
    "title": "TOBY – your website for {price} a month",
    "meta_description": "Your website for {price} a month. No setup fee, cancel any month. Change it by voice message, chat or photo.",
    "nav_label": "Main navigation",
    "footer_label": "Footer",
    "nav_how": "How it works",
    "nav_price": "Price",
    "nav_faq": "Questions",
    "cta_app": "Get the TOBY app",
    "hero_eyebrow": "The website manager from Munich",
    "hero_line_1": "Your website.",
    "hero_line_2": "{price} a month.",
    "hero_sub": "No setup fee. Cancel any month. Changes simply by voice message, chat or photo.",
    "hero_note": "Ready in 5 minutes. Online today.",
    "medal_over": "Over",
    "medal_years": "years of experience",
    "medal_app": "in one app",
    "price_only": "Only",
    "price_month_incl_vat": "a month incl. VAT",
    "price_month_plus_tax": "a month plus applicable tax",
    "setup_zero": "Setup {zero}",
    "bar_setup": "No setup fee",
    "bar_term": "No minimum term",
    "bar_domain": "Your own domain included",
    "bar_pc": "No computer needed",
    "compare_heading": "Websites used to be expensive and complicated.",
    "compare_heading_accent": "Not anymore.",
    "compare_old_label": "With a web designer",
    "compare_old_1": "Hundreds to thousands of euros up front, before anything is online.",
    "compare_old_2": "Every change: write an email, wait, pay extra.",
    "compare_old_3": "Site builder, passwords, dashboard. On a computer.",
    "compare_old_4": "Hosting, domain and email cost extra.",
    "compare_new_label": "With TOBY",
    "compare_new_1_lead": "Setup: {zero}.",
    "compare_new_1_text": "You only pay {price} a month.",
    "compare_new_2_lead": "Changes: just say them.",
    "compare_new_2_text": "TOBY does it right away.",
    "compare_new_3_lead": "No site builder.",
    "compare_new_3_text": "Everything from your phone.",
    "compare_new_4_lead": "Everything included.",
    "compare_new_4_text": "Domain, email address, hosting.",
    "how_heading": "It's that simple.",
    "how_1_title": "Send a photo",
    "how_1_text": "Take a photo of your shop, your business card, your menu or your price list. TOBY builds your website from it.",
    "how_2_title": "Say what changes",
    "how_2_text": "“We’re now open on Saturdays too.” One sentence and your website is up to date.",
    "how_3_title": "Done.",
    "how_3_text": "Your website is online. You take care of your business, TOBY takes care of the rest.",
    "app_eyebrow": "The TOBY app",
    "app_heading": "Your website",
    "app_heading_accent": "in your pocket.",
    "app_text": "Look after your website wherever you are: behind the counter, on the building site, in the salon. Press the button, say what changes. Done.",
    "app_say": "Say it to TOBY: just speak",
    "app_write": "Write it to TOBY: chat with TOBY",
    "app_show": "Show it to TOBY: send a photo",
    "store_now": "Get it on",
    "app_iphone_note": "iPhone app: coming soon to the App Store. Until then, TOBY works on your iPhone right in the browser:",
    "app_iphone_link": "start here",
    "app_iphone_end": ".",
    "mock_hello": "Hello, I'm TOBY.",
    "mock_intro": "Tell me what has changed. I'll take care of your website.",
    "mock_user_1": "We're now open on Saturdays too.",
    "mock_toby_1": "Done. Your opening hours are updated everywhere.",
    "mock_user_2": "Here is our new price list.",
    "mock_toby_2": "Thanks! I've added the prices. Shall I publish?",
    "mock_input": "Just speak …",
    "price_heading": "One price.",
    "price_heading_accent": "Everything included.",
    "price_text": "No plans to compare, no hidden costs.",
    "price_per_month": "a month",
    "price_incl_vat": "incl. VAT",
    "price_note": "No setup fee · Cancel any month",
    "feature_domain": "Your own domain included: your-name.com or .net",
    "feature_domain_move": "Moving your existing domain included",
    "feature_mailbox": "Email address like info@your-name.com with a large mailbox (15 GB)",
    "feature_input": "Say it, write it or show it to TOBY: by voice message, chat or photo",
    "feature_upload": "Photo, PDF, Word and Excel upload",
    "feature_pages": "Up to 15 pages",
    "feature_language": "Automatically translated into one more language",
    "feature_newsletter": "Your own newsletter: 1,000 emails a month",
    "feature_stats": "Visitor statistics",
    "feature_hosting": "Hosted in the EU",
    "feature_starter": "Starter pack by post: TOBY sticker for your door and an A5 sign with a QR code for newsletter sign-ups",
    "extras_heading": "Extras as you need them",
    "extras_note": "{price} each a month incl. VAT · each one cancellable monthly",
    "extras_note_plus_tax": "{price} each a month plus applicable tax · each one cancellable monthly",
    "extra_mailbox": "Another email address with a large mailbox (15 GB)",
    "extra_language": "Another language (with automatic translation)",
    "extra_pages": "15 more pages",
    "extra_newsletter": "Each further 5,000 newsletter emails",
    "testimonials_heading": "Real businesses.",
    "testimonials_heading_accent": "Real websites.",
    "chip_food": "Cafés & restaurants",
    "chip_shops": "Shops & stores",
    "chip_salons": "Hairdressers & salons",
    "chip_trades": "Trades & construction",
    "chip_studios": "Studios & freelancers",
    "chip_coaches": "Coaches & tutors",
    "faq_heading": "Any questions?",
    "faq_catch_q": "What's the catch?",
    "faq_catch_a": "There isn't one. No setup fee, no minimum term: you pay {price} a month and can cancel any month.",
    "faq_tech_q": "Do I need any technical skills?",
    "faq_tech_a": "No. If you can send a voice message, you can look after your website.",
    "faq_domain_q": "Can I use my own domain?",
    "faq_domain_a": "Yes. A new domain is included. We move your existing domain for you free of charge.",
    "faq_undo_q": "What if I don't like a change?",
    "faq_undo_a": "Every change goes into a draft first. If you don't like it, undo it with one sentence.",
    "faq_cancel_q": "How do I cancel?",
    "faq_cancel_a": "With one click, no phone call.",
    "closing_heading": "No more expensive websites.",
    "closing_text": "No setup fee. {price} a month. Cancel any month.",
    "footer_since": "{legal}, since 2000"
  },
  "app_download": {
    "heading": "Get the",
    "heading_accent": "TOBY app.",
    "text": "Scan the code with your phone or choose your store. Your website can be online in 5 minutes.",
    "store_soon": "Coming soon to",
    "store_live": "Download on the",
    "iphone_note": "On an iPhone?",
    "iphone_link": "Start in your browser now",
    "qr_alt": "QR code for {url}",
    "qr_label": "Scan with your phone",
    "step_1": "Get the app",
    "step_3": "Send a photo. Done."
  },
  "website_settings": {
    "title": "Website settings"
  },
  "settings": {
    "title": "User settings",
    "nav": {
      "profile": "Profile",
      "sessions": "Sessions",
      "appearance": "Appearance",
      "subscription": "Subscription",
      "site_address": "Site address",
      "contact_email": "Contact email",
      "design": "Design",
      "domain_takeover": "Domain",
      "password_protection": "Password",
      "data_export": "Download your data",
      "uploads": "Library",
      "memory": "Memory",
      "notifications": "Notifications",
      "sounds": "Sounds",
      "voice": "Voice",
      "privacy": "Privacy",
      "analytics": "Analytics",
      "newsletter": "Newsletter",
      "email": "Email",
      "messages": "Messages",
      "referral": "Refer"
    },
    "uploads": {
      "description": "Manage your uploaded files and images.",
      "empty": "No files uploaded yet.",
      "added": "Added: {date}",
      "kind_image": "Image",
      "kind_document": "Document",
      "kind_animation": "Animation",
      "kind_video": "Video",
      "video_preparing": "Preparing your video… This usually takes a few minutes.",
      "video_held_badge": "Processing",
      "video_terms_badge": "Not allowed",
      "video_terms": "This video goes against our Terms of Service, so it won't appear on your website. You can send a different one. Questions? Write to support@tobysite.com.",
      "video_held": "We're still processing this video, so it isn't on your website yet. Questions? Write to support@tobysite.com.",
      "video_failed": "We couldn't prepare this video. Please upload it again, or try a different clip.",
      "delete": "Delete file",
      "confirm_delete": "Are you sure you want to delete this file?",
      "cancel": "Cancel",
      "images_inside": "{count, plural, one {1 image inside} other {# images inside}}",
      "inside_back": "Back to files & images",
      "inside_title": "Images inside {filename}",
      "inside_note": "These images were found inside your PDF. They're kept out of your files list, but you can add any of them to a page anytime — just ask in chat.",
      "inside_empty": "No images were found inside this document.",
      "tab_all": "All",
      "tab_images": "Images",
      "tab_videos": "Videos",
      "tab_documents": "Documents",
      "add": "Add files",
      "added_video": "{count, plural, one {Video added} other {# videos added}}",
      "added_image": "{count, plural, one {Image added} other {# images added}}",
      "added_document": "{count, plural, one {Document added} other {# documents added}}",
      "already_in_library": "{filename} is already in your Library as #{number}",
      "unsupported": "{filename} can't be added. You can add images, videos, PDFs, Word and Excel files, and animations.",
      "upload_failed": "Couldn't add {filename}"
    },
    "profile": {
      "title": "Profile information",
      "description": "Update your display name",
      "name_label": "Name",
      "name_placeholder": "Full name",
      "save": "Save",
      "saved": "Saved.",
      "delete": {
        "title": "Delete account",
        "description": "Takes your websites offline and deletes your account.",
        "button": "Delete account",
        "confirm_title": "Delete your account?",
        "confirm_description": "Your websites go offline right away and you will be signed out. Changed your mind later? Contact us within 30 days and we'll restore everything — after that it's permanently gone.",
        "confirm": "Yes, delete my account",
        "cancel": "Cancel"
      }
    },
    "sessions": {
      "title": "Sessions",
      "description": "Manage your active sessions across devices",
      "current": "Current",
      "ip": "IP",
      "active_since": "Active since",
      "log_out": "Log out"
    },
    "appearance": {
      "title": "Appearance settings",
      "description": "Update your account's appearance settings",
      "label": "Appearance",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "subscription": {
      "title": "Subscription",
      "description": "Your current plan and billing",
      "no_subscription": "You don't have a subscription yet.",
      "current_plan": "Current plan",
      "free_until": "Free until {date}",
      "free_until_cta": "Free until {date} · Add payment details",
      "period_end": "Renews {date}",
      "choose_plan": "Choose a plan",
      "billing_account": "Billing account",
      "change_plan": "Change plan",
      "no_active_plan": "No active plan",
      "plans_per_website": "Plans per website",
      "manage": "Manage billing",
      "status": {
        "trialing": "Trial",
        "active": "Active",
        "past_due": "Past due",
        "canceled": "Canceled",
        "paused": "Paused"
      },
      "native_note": "You can manage your plans on the tobysite website.",
      "interval_switch": {
        "paying_month": "You pay monthly.",
        "paying_year": "You pay yearly.",
        "offer_title_year": "Switch to yearly payment",
        "offer_title_year_savings": "Pay yearly and save {savings}",
        "offer_title_month": "Switch to monthly payment",
        "offer_body_year": "From {date} you'd pay {total} per year ({tax}) instead of {current} per month. Nothing changes before then, and you can undo the switch until that date.",
        "offer_body_month": "From {date} you'd pay {total} per month ({tax}) instead of {current} per year. Nothing changes before then, and you can undo the switch until that date.",
        "line_year": "{site} · {plan}: {amount} / year",
        "line_month": "{site} · {plan}: {amount} / month",
        "switch_year": "Switch to yearly",
        "switch_month": "Switch to monthly",
        "confirm_title_year": "Switch to yearly payment?",
        "confirm_title_month": "Switch to monthly payment?",
        "confirm_body_year": "Your next payment on {date} will be {total} for the whole year ({tax}). After that, once a year. You can undo this until {date}.",
        "confirm_body_month": "Your next payment on {date} will be {total} for one month ({tax}). After that, once a month. You can undo this until {date}.",
        "confirm": "Yes, switch",
        "cancel": "Not now",
        "pending_year": "Your payment switches to yearly on {date}. Nothing changes before then.",
        "pending_month": "Your payment switches to monthly on {date}. Nothing changes before then.",
        "pending_portal_note": "While the switch is pending, changes in the billing portal (such as cancelling) aren't possible. Undo the switch first if you need them.",
        "undo": "Undo switch"
      }
    },
    "newsletter": {
      "title": "Newsletter",
      "description": "People who signed up for updates from your website.",
      "cannot_send_heading": "Newsletters aren't part of your current plan",
      "cannot_send_body": "Upgrade to a plan that includes the newsletter to collect subscribers, print a sign-up poster, and email updates to people who follow your website.",
      "see_plans": "See plans",
      "manage": "Manage {count, plural, one {# subscriber} other {# subscribers}}",
      "no_subscribers": "No one has signed up for your newsletter yet.",
      "print_poster": "Print sign-up poster",
      "subscribers_heading": "Subscribers",
      "mailings_heading": "Your newsletters",
      "new_mailing": "New newsletter",
      "no_mailings": "You haven't written any newsletters yet.",
      "untitled": "Untitled",
      "status_draft": "Draft",
      "status_scheduled": "Scheduled",
      "status_sending": "Sending",
      "status_sent": "Sent",
      "delete_mailing": "Delete newsletter",
      "mailing_deleted": "Newsletter deleted.",
      "delete_title": "Delete this newsletter?",
      "delete_description": "“{subject}” will be deleted for good. This can't be undone.",
      "delete_cancel": "Cancel",
      "confirm_delete": "Yes, delete",
      "poster_language": "Poster language",
      "poster": {
        "back": "Back to TOBY",
        "title": "Sign-up poster",
        "print": "Print",
        "pick_page": "This poster links to",
        "no_signup": "Add a sign-up form to one of your pages first — for now this poster links to your homepage."
      },
      "subscribers": {
        "title": "Newsletter subscribers",
        "title_count": "Newsletter subscribers ({count})",
        "description": "Everyone who signed up for updates from {site}.",
        "back": "Newsletter",
        "add": "Add subscriber",
        "add_title": "Add a subscriber",
        "add_description": "Add someone who gave you their email in person. Only add people who agreed to hear from you.",
        "edit_title": "Edit subscriber",
        "email_label": "Email",
        "email_placeholder": "name@example.com",
        "name_label": "Name",
        "name_placeholder": "Optional",
        "save": "Save",
        "cancel": "Cancel",
        "edit": "Edit",
        "remove": "Remove",
        "remove_title": "Remove subscriber?",
        "remove_description": "{email} will stop receiving your newsletter. You can add them again later.",
        "confirm_remove": "Yes, remove",
        "empty": "No subscribers yet.",
        "added": "Subscriber added.",
        "updated": "Subscriber updated.",
        "removed": "Subscriber removed.",
        "col_email": "Email",
        "col_name": "Name",
        "col_actions": "Actions"
      }
    },
    "email_notifications": {
      "paused_title": "Email notifications are paused",
      "paused_body": "A message from your website was marked as spam in your inbox, so we've paused emailing you new messages. They're still saved in Messages — resume to get them by email again.",
      "resume": "Resume email notifications"
    },
    "messages": {
      "title": "Messages",
      "title_count": "Messages ({count})",
      "description": "Everything visitors sent through the forms on your website — even if an email goes missing, it's saved here. Messages are kept for 12 months.",
      "nav_description": "Messages and orders from your website's forms.",
      "back": "Back to messages",
      "empty": "No messages yet. When someone fills in a form on your website, it will show up here.",
      "col_from": "From",
      "col_message": "Message",
      "col_date": "Date",
      "col_actions": "Actions",
      "order_badge": "Order",
      "email_failed_badge": "Email not delivered",
      "email_failed_hint": "We couldn't deliver this message to your email inbox — it's safely stored here.",
      "email_suppressed_badge": "Email paused",
      "email_suppressed_hint": "This message wasn't emailed to you because email notifications are paused — it's safely stored here.",
      "items_heading": "Order",
      "reply": "Reply to {email}",
      "remove": "Delete",
      "remove_title": "Delete this message?",
      "remove_description": "The message will be removed from your inbox. This can't be undone.",
      "cancel": "Cancel",
      "confirm_remove": "Yes, delete",
      "archive": "Archive",
      "unarchive": "Unarchive",
      "archived_badge": "Archived",
      "archived_heading": "Archived ({count})",
      "empty_inbox": "No new messages — everything is archived below.",
      "copy_link": "Copy link",
      "link_copied": "Link copied"
    },
    "site_address": {
      "title": "Site address",
      "description": "Choose your free toby.site web address.",
      "explainer": "This is the web address where people find your site. Pick something short and memorable — you can set it once, so choose carefully.",
      "claimed_note": "Your web address is set and can only be chosen once. Contact support if you really need to change it.",
      "current": "Current address:",
      "form": {
        "label": "Choose your address",
        "placeholder": "your-business",
        "help": "Your site will be at {address}",
        "submit": "Save address"
      },
      "saved": "Saved",
      "already_custom": "Your site uses your own domain ({domain}), so there's no toby.site address to change."
    },
    "contact_email": {
      "title": "Contact email",
      "description": "The email address for your business — newsletter replies go here, and your TOBY assistant uses it when working on your website.",
      "form": {
        "label": "Contact email",
        "placeholder": "hello@yourbusiness.com",
        "help": "Replies to your newsletters go to this address. Your TOBY assistant also knows it — for example when it adds contact details to your pages.",
        "fallback_hint": "This is empty right now, so newsletter replies go to your account email instead: {email}.",
        "submit": "Save contact email"
      },
      "saved": "Saved"
    },
    "domain_takeover": {
      "title": "Domain",
      "description": "Your website's address — get your included domain or connect one you own.",
      "upsell": {
        "title": "Use your own domain",
        "body": "Custom domains are part of the Business plan. Upgrade to put your website on a domain you own.",
        "cta": "See plans"
      },
      "awaiting_payment": {
        "title": "Your domain is almost ready",
        "body": "Your first payment is still on its way — a direct debit usually takes about six business days to clear. As soon as it has, you can pick your domain right here. Until then, your website stays live at {domain}.",
        "support_lead": "Taking longer than that?",
        "support_link": "Email our support team",
        "support_subject": "My domain for {domain}",
        "support_body": "Hello TOBY team,\n\nI'm waiting for my first payment to clear so I can get the domain for my website {domain}. Could you check how far along it is?\n\nThank you"
      },
      "not_published": "Publish your website first, then you can move it to your own domain.",
      "already_custom": "Your website is already on a custom domain ({domain}).",
      "form": {
        "label": "Your domain",
        "placeholder": "www.yourbusiness.com",
        "help": "Enter a domain you already own. We'll give you one record to add at your domain provider.",
        "submit": "Start setup"
      },
      "status": {
        "pending_dns": "Waiting for DNS",
        "validating": "Checking",
        "active": "Live",
        "failed": "Needs attention"
      },
      "pending": {
        "body": "Add this record at your domain provider. Your site switches over automatically once it's verified — this can take up to an hour.",
        "host_hint": "Still waiting? Many domain providers want only “{label}” in the Name field and add the rest of your address themselves."
      },
      "progress": {
        "pending_dns": "Add the record below — we'll detect it automatically.",
        "validating": "Verifying your domain and setting up HTTPS — almost there."
      },
      "active": {
        "title": "Your website is live at {hostname}.",
        "visit": "Open website"
      },
      "failed": {
        "body": "We couldn't verify your domain. Check the records at your provider and try again, or remove it and start over."
      },
      "recheck": "Check again",
      "copy": "Copy",
      "copied": "Copied",
      "cancel": "Cancel setup",
      "remove": "Remove custom domain",
      "confirm": {
        "title": "Remove this custom domain?",
        "body": "Your website goes back to its toby.site address. You can set up a custom domain again later.",
        "cancel": "Keep it",
        "button": "Remove"
      }
    },
    "email": {
      "title": "Email",
      "description": "Email addresses on your own domain",
      "nav_description": "Your email addresses and inboxes",
      "status": {
        "pending": "We're setting up email for {domain} — this usually takes a few minutes.",
        "active": "Email for {domain} is up and running.",
        "action_required": "Something needs attention on our side. We're on it — your addresses are safe."
      },
      "upsell": {
        "title": "Email comes with the Business plan",
        "body": "Get email addresses on your own domain — like info@your-domain.com — with webmail and forwarding included.",
        "cta": "See plans"
      },
      "needs_domain": {
        "title": "Email needs your own domain",
        "body": "Email addresses live on your own domain, like info@your-cafe.com. Connect a domain to your website and email is ready to switch on.",
        "cta": "Connect a domain"
      },
      "available": {
        "title": "Turn on email for {domain}",
        "body": "Create addresses like info@{domain}, with webmail included in your plan.",
        "switch_confirm": "I understand — move my email to TOBY",
        "manual_hint": "Your domain stays where it is — after you turn email on, we show you exactly what to send to the person who manages it.",
        "cta": "Turn on email",
        "switch_warning_named": "Your email for this domain currently runs at {provider}. Turning on TOBY email moves it here — new messages arrive at TOBY, and the old inbox stops receiving them.",
        "switch_warning_generic": "Your email for this domain currently runs with another provider. Turning on TOBY email moves it here — new messages arrive at TOBY, and the old inbox stops receiving them.",
        "switch_details": "Technical details"
      },
      "mailboxes": {
        "title": "Your email addresses",
        "description": "Each address has its own inbox and password.",
        "add_link": "Add another address"
      },
      "aliases": {
        "title": "Extra names",
        "description": "Extra addresses that land in an inbox you already have.",
        "add_link": "Add an extra name — like bookings@ — that lands in an existing inbox"
      },
      "form": {
        "address_label": "Address",
        "name_label": "Name (optional)",
        "name_placeholder": "e.g. Maria García",
        "target_label": "Lands in",
        "create_mailbox": "Create address",
        "create_alias": "Add name",
        "suggestions": "info,hello,bookings"
      },
      "setting_up": "Setting up…",
      "password_pending": "Show password",
      "paused": "Paused",
      "dns": {
        "title": "Your domain needs a few email settings",
        "body": "Send these to the person who manages your domain — or add them yourself where the domain is hosted. We check automatically and switch everything on once they're in place.",
        "type": "Type",
        "host": "Host",
        "value": "Value",
        "status": "Status",
        "ok": "Found",
        "missing": "Waiting",
        "copy_all": "Copy all",
        "copied": "Copied",
        "copy_row": "Copy",
        "send_email": "Send by email",
        "email_subject": "Email settings for {domain}"
      },
      "reveal": {
        "title": "Your email password",
        "body": "Copy it somewhere safe — we can only show it once. You'll need it to open your inbox and to set up email on your phone. You can always get a new one later.",
        "copy": "Copy password",
        "copied": "Copied",
        "done": "Done"
      },
      "reset": {
        "title": "New password for {address}?",
        "body": "This replaces the current password. Mail keeps arriving — but you'll need the new password in your mail apps and webmail.",
        "confirm": "Set new password"
      },
      "delete": {
        "title": "Delete {address}?",
        "mailbox_body": "This mailbox stops receiving right away and its stored mail will be deleted.",
        "alias_body": "Messages sent to this address will no longer arrive.",
        "confirm": "Delete"
      },
      "cancel": "Cancel",
      "toasts": {
        "deleted": "Address removed."
      },
      "first_run": {
        "title": "Create your email address",
        "body": "Pick what comes before the @ — most businesses use info."
      },
      "actions": {
        "open_inbox": "Open inbox",
        "reset_password": "New password",
        "delete": "Delete"
      },
      "phone_hint": "Want this email on your phone? Add the address in your phone's Mail app — it asks for the address and your email password.",
      "setup_guide": "Step-by-step guide for phone and computer",
      "backup_hint": "Your mail is kept on the mail server, not in TOBY, and is not part of your website download. To keep a copy, add the mailbox to a mail app on a computer — it downloads everything. After a cancellation, mail is deleted {days} days after your plan ends."
    },
    "design": {
      "title": "Design",
      "description": "Set your colors, fonts, and how rounded your boxes and images look.",
      "preview_light": "Light",
      "preview_dark": "Dark",
      "saved": "Saved",
      "reset": "Reset to default",
      "save": "Save design",
      "publish_hint": "Publish your site to make the change live.",
      "brand": {
        "title": "Brand color",
        "explainer": "Pick one color for your site. We use it for your page headings and links, and keep it easy to read on both light and dark screens.",
        "custom_label": "Pick your own",
        "custom_hint": "Any color works — we'll keep it readable on a white background.",
        "clamped": "We darkened this a little so it stays readable on white.",
        "preview_heading": "Your heading",
        "preview_body": "Body text stays easy to read, and",
        "preview_link": "this is a link"
      },
      "secondary": {
        "title": "Secondary color",
        "explainer": "Used as the background for cards. We automatically pick a text color and brightness that stay easy to read.",
        "custom_label": "Pick your own",
        "custom_hint": "Any color works — we'll set readable text on top automatically.",
        "preview_label": "Preview",
        "preview_card_heading": "A card",
        "preview_card_body": "This block stands out from the rest of the page."
      },
      "corner": {
        "title": "Corners",
        "explainer": "Choose how rounded your boxes and images look. This applies across your whole site.",
        "options": {
          "square": "Square",
          "xs": "Barely rounded",
          "sm": "Slightly rounded",
          "md": "Rounded",
          "lg": "Very rounded",
          "xl": "Fully rounded"
        }
      },
      "logo": {
        "light_label": "Logo",
        "light_hint": "Shown in your site header. Used in both light and dark mode unless you add a dark version below.",
        "dark_label": "Dark mode logo",
        "dark_hint": "Optional. Shown when someone views your site in dark mode. Leave empty to use your main logo everywhere.",
        "none": "No logo",
        "upload": "Upload logo",
        "replace": "Replace",
        "uploading": "Uploading…",
        "remove": "Remove",
        "upload_failed": "That didn't upload. Please try again.",
        "not_image": "Please choose an image file."
      },
      "favicon": {
        "label": "Browser icon (favicon)",
        "hint": "The small icon shown in the browser tab and next to bookmarks. Use a square image. PNG shows in every browser; SVG stays sharp at any size.",
        "none": "No icon",
        "upload": "Upload icon"
      },
      "header_text": {
        "label": "Header text",
        "hint": "Optional short text shown in the header next to your logo — like “Docs” or “Shop”. Leave empty to show just your logo (or your site name when there's no logo).",
        "placeholder": "e.g. Docs"
      },
      "announcement": {
        "label": "Announcement banner",
        "hint": "Shown highlighted at the top of every page — for temporary notices like holidays or changed hours.",
        "placeholder": "We'll be closed 3–24 August"
      },
      "header": {
        "title": "Header",
        "explainer": "How the top of every page is arranged.",
        "options": {
          "left": "Classic",
          "center": "Centered"
        }
      },
      "divider": {
        "title": "Divider lines",
        "explainer": "The thin lines that separate the header and footer from the page.",
        "options": {
          "line": "Line",
          "none": "None",
          "bold": "Bold"
        }
      },
      "page_top": {
        "title": "Top spacing",
        "explainer": "How much room sits between the header and your content.",
        "options": {
          "airy": "Spacious",
          "flush": "Compact"
        }
      },
      "font": {
        "title": "Fonts",
        "explainer": "Choose the typeface for your site. You can give your headlines a different font from your body text.",
        "body_label": "Body text",
        "body_hint": "The main font used across your site.",
        "headline_label": "Headlines",
        "headline_hint": "The font for your page headings. Leave on \"Same as body text\" to match your body font.",
        "default_option": "Default",
        "same_as_body": "Same as body text",
        "options": {
          "business": "Business — clean sans",
          "editorial": "Editorial — classic serif",
          "cute": "Cute — rounded sans",
          "futuristic": "Futuristic — geometric",
          "playful": "Playful — soft display",
          "mono": "Mono — monospace"
        }
      }
    },
    "data_export": {
      "title": "Download your data",
      "description": "Get a copy of everything TOBY holds for this website.",
      "includes_title": "What is in the download",
      "includes": {
        "pages": "The text of every page",
        "library": "Photos and files from your library",
        "inbox": "Messages from your contact form",
        "newsletter": "Newsletter subscribers and mailings",
        "conversations": "Your conversations with TOBY",
        "settings": "Your website settings and account details"
      },
      "excludes_mail": "Email is not included: your mail is kept on the mail server, not in TOBY.",
      "excludes_mail_link": "How to keep a copy of your mail",
      "request": "Prepare my download",
      "preparing": "We're preparing your download. This can take a few minutes; we'll also email you when it's ready.",
      "ready_until": "Available until {date} · {size}",
      "download": "Download",
      "expired": "Your last download has expired. Prepare a new one whenever you need it.",
      "failed": "Something went wrong while preparing your download. Please try again.",
      "cooldown": "You can request a new download on {date}"
    },
    "password_protection": {
      "title": "Password protection",
      "description": "Hide your published site behind a password only you share.",
      "explainer": "When this is on, visitors must enter the password before they can see any page of your site. Changing or removing it signs out everyone who entered the old one. You can still edit and preview your site normally.",
      "status_on": "Password on",
      "set_label": "Site password",
      "change_label": "New password",
      "placeholder": "Enter a password",
      "set_button": "Turn on password",
      "change_button": "Change password",
      "saved": "Saved",
      "remove": {
        "title": "Remove password",
        "description": "Make your site public again. Anyone with the link will be able to see it.",
        "button": "Remove password",
        "confirm_title": "Remove password protection?",
        "confirm_description": "Your site will be public again immediately. Anyone with the link will be able to view it.",
        "cancel": "Cancel",
        "confirm": "Remove password"
      }
    },
    "memory": {
      "title": "Memory",
      "description": "What TOBY remembers about {site}, so you don't have to repeat yourself.",
      "nav_description": "What TOBY remembers about your business.",
      "facts_title": "About your business",
      "facts_description": "Details TOBY keeps in mind and uses when writing your website and emails.",
      "facts_add": "Add a fact",
      "facts_empty": "Nothing yet. Add things like your opening hours or which number is for orders.",
      "prefs_title": "How TOBY writes",
      "prefs_description": "How you'd like TOBY to write: tone, wording, and small rules to always follow.",
      "prefs_add": "Add a preference",
      "prefs_empty": "Nothing yet. Add things like \"write announcements in capitals\".",
      "edit": "Edit",
      "remove": "Remove",
      "fact_placeholder": "e.g. Orders line is +49 30 123 456",
      "pref_placeholder": "e.g. Write announcements in capitals",
      "add_title": "Add",
      "edit_title": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "remove_title": "Remove this?",
      "remove_description": "TOBY will forget: \"{text}\"",
      "confirm_remove": "Remove"
    },
    "notifications": {
      "title": "Notifications",
      "description": "What TOBY tells you about, and where.",
      "channel_push": "You get these on your phone, in the TOBY app.",
      "channel_email": "You get these by email, to {email}.",
      "always_sent": "Always sent",
      "saved": "Saved.",
      "items": {
        "weekly_nudge": {
          "label": "Weekly ideas",
          "hint": "A suggestion for your website when TOBY spots something worth updating, plus news from TOBY. Most weeks there's nothing."
        },
        "unpublished_changes": {
          "label": "Unpublished changes",
          "hint": "A reminder when edits to your website have been waiting to go live."
        },
        "site_published": {
          "label": "Website is live",
          "hint": "A notification in the TOBY app once your changes are online, in case you've stepped away while they go live."
        },
        "contact_message": {
          "label": "Contact form messages",
          "hint": "A heads-up when someone writes to you through your website. Every message is also saved in Messages, so nothing is lost if an email goes missing."
        },
        "billing": {
          "label": "Payments and plan",
          "hint": "Payments, failed payments and changes to your plan."
        },
        "domain": {
          "label": "Your domain",
          "hint": "Renewals, transfers and anything your domain needs from you."
        }
      }
    },
    "sounds": {
      "title": "Sounds",
      "description": "Hear when TOBY changes your website and when it goes live.",
      "explainer": "TOBY plays a short sound when it makes a change to your website, and a different one once your website has finished going live — handy when you're talking to TOBY and not watching the screen.",
      "label": "Play sounds while I work on my website",
      "saved": "Saved."
    },
    "voice": {
      "title": "Voice",
      "description": "Choose how you talk to TOBY.",
      "explainer": "With voice notes, the microphone is only on after you tap it, not the whole time. Say everything you want changed, and TOBY does it and tells you what it did. While you talk, you can tap anything on your website to show TOBY what you mean. Turn this off to talk to TOBY in an open conversation instead.",
      "label": "Talk to TOBY in voice notes",
      "saved": "Saved.",
      "trial_note": "During your free trial you talk to TOBY in voice notes. With a plan you can choose the open conversation too."
    },
    "privacy": {
      "title": "Privacy",
      "description": "Your consent choices and the terms you accepted.",
      "research_hint": "Details are in our {privacy}.",
      "terms_accepted": "You accepted the {terms} on {date}.",
      "marketing_title": "Marketing emails",
      "marketing_hint": "Tips for your website, product news, and the occasional request for feedback or a review. Every email has a link to unsubscribe.",
      "saved": "Saved."
    },
    "domain": {
      "get_title": "Get your included domain",
      "get_body": "Your plan includes a real domain (e.g. .de or .com). Check a name and register it — or move a domain you already own to TOBY.",
      "input_placeholder": "kaffee-mueller.de",
      "check": "Check",
      "checking": "Checking…",
      "available": "{name} is available!",
      "taken": "{name} is already taken.",
      "unsupported": "Please use one of these endings: {tlds}.",
      "check_failed": "Couldn't check right now — please try again.",
      "register_cta": "Register {name}",
      "transfer_cta": "I already own this domain — move it to TOBY",
      "transfer_offer_title": "Your domain is included in your plan",
      "transfer_offer_body": "{domain} is currently registered with another provider. Move it to TOBY and we'll manage and renew it for you — included in your plan. You'll need the transfer code (auth code) from your current provider.",
      "transfer_offer_cta": "Move {domain} to TOBY",
      "connect_title": "Keep your domain where it is",
      "connect_body": "Already have a domain and want to leave it with your current provider? Point it at your website instead.",
      "registration": {
        "badge": {
          "pending": "In progress",
          "active": "Live",
          "failed": "Failed",
          "action_required": "Being checked"
        },
        "kind": {
          "purchase": "Registered through TOBY",
          "transfer": "Transferred to TOBY"
        },
        "status": {
          "pending": "We're setting up {name}. This usually takes a few minutes — moving a .com can take a few days. Your site stays online the whole time.",
          "active": "Your website is live on {name}.",
          "failed": "The order for {name} didn't go through — nothing was charged. Check your details below and try again.",
          "action_required": "We're double-checking something on {name}. Nothing to do on your side — we'll follow up."
        },
        "renewal_on": "Renews automatically (next period ends {date}).",
        "renewal_off": "Auto-renewal is off — registered until {date}."
      }
    },
    "referral": {
      "title": "Refer",
      "description": "Recommend TOBY to other business owners. If they sign up and pay, you both get a month free.",
      "inactive_note": "Your code becomes active as soon as your first payment has arrived.",
      "code_label": "Your code",
      "link_label": "Your link",
      "copy_link": "Copy link",
      "send_invitation": "Send an invitation message",
      "share_message": "I run my website with TOBY now – it changes when I tell it what should be different. If you start through my link, we both get a month free: {link}",
      "show_name_label": "Show my name on the referral page",
      "show_name_hint": "Otherwise it reads “A customer recommends TOBY.”",
      "saved": "Saved.",
      "how_title": "How the reward works",
      "how_body": "For every referral that pays, you get one month of your plan free, but never more than a month of the plan your referral chose is worth. If you pay monthly, it is deducted from your next invoice; if you pay yearly, it is usually refunded on your last payment. Up to {cap} referrals per year.",
      "this_year": "This year: {count} of {cap}",
      "list_title": "Your referrals",
      "empty": "No referrals yet. Share your link – as soon as someone signs up through it, you will see it here.",
      "new_signup": "New signup",
      "status": {
        "waiting": "Signed up – waiting for the first payment",
        "held": "Paid – your yearly limit is reached",
        "credited": "Credit booked",
        "refunded": "Amount refunded",
        "reversed": "Reversed"
      }
    }
  },
  "plans": {
    "easy": {
      "name": "Easy"
    },
    "business": {
      "name": "Business"
    },
    "premium": {
      "name": "Premium"
    },
    "max": {
      "name": "Max"
    },
    "ultimate": {
      "name": "Ultimate"
    },
    "heading_1": "Simple.",
    "heading_2": "Fast.",
    "heading_3": "Works.",
    "meta_description": "One plan with everything included: your website, your own domain and an email address. No setup fee.",
    "subheading": "One price. Everything included. No setup fee.",
    "or_yearly": "or {price} / year",
    "billing_interval": "Toggle monthly or yearly billing",
    "yearly": "Yearly",
    "monthly": "Monthly",
    "monthly_only": "Only available as a monthly plan",
    "sepa_note": "Pay by IBAN direct debit too, for {flag} customers",
    "per_month": "/ month",
    "billed_yearly": "Billed {price} yearly — 2 months free",
    "incl_vat": "incl. VAT",
    "net_price": "{price} net",
    "plus_tax": "plus applicable tax",
    "b2b_disclaimer": "Prices include statutory VAT for customers in the EU; elsewhere, applicable tax is added at checkout. {brand} is a service for businesses.",
    "easy_name": "Easy",
    "easy_tagline": "Your business online — simple, smart and affordable.",
    "domain_included": "Your own domain included —",
    "domain_choice": "You can choose any of these domain addresses:",
    "domain_worldwide": "Worldwide",
    "domain_europe": "Europe",
    "chat_anytime": "Chat with TOBY anytime",
    "say_toby": "🎤 Tell TOBY – just say what to change",
    "write_toby": "⌨️ Write to TOBY – chat with TOBY",
    "show_toby": "📷 Show TOBY – send a photo",
    "visitor_stats": "Visitor statistics",
    "no_cookie_banner": "No cookie banner needed",
    "file_uploads": "Photo, PDF, Word &amp; Excel upload",
    "easy_f2": "Your own toby.site web address",
    "easy_f4": "Up to 7 pages",
    "easy_f6": "Newsletter &mdash; 200 emails / month",
    "easy_cta": "Start Easy",
    "business_name": "Business",
    "business_tagline": "The complete setup for everyday business.",
    "business_f3": "Up to 15 pages",
    "business_f4": "Auto-translated into 1 more language",
    "business_f6": "Newsletter &mdash; 1,000 emails / month",
    "business_f7": "1 email address",
    "business_cta": "Start Business",
    "premium_name": "Premium",
    "premium_tagline": "For businesses that want more.",
    "premium_f3": "Up to 30 pages",
    "premium_f4": "Auto-translated into 3 more languages",
    "premium_f6": "Newsletter &mdash; 5,000 emails / month",
    "premium_f7": "3 email addresses",
    "premium_cta": "Start Premium",
    "max_name": "Max",
    "max_tagline": "Businesses that want more.",
    "max_f2": "Talk to TOBY by voice",
    "max_f3": "Up to 50 pages &middot; 5 languages",
    "max_f4": "+ PDF, Word, Excel &amp; menus",
    "max_f5": "Newsletter &mdash; 5,000 emails / month",
    "max_f6": "Priority support",
    "max_f7": "Email &mdash; 3 inboxes (15 GB each) + 25 aliases",
    "max_cta": "Start Max",
    "ultimate_name": "Ultimate",
    "ultimate_tagline": "For larger companies and international brands.",
    "ultimate_f2": "Talk to TOBY by voice",
    "ultimate_f3": "Up to 100 pages &middot; 10 languages",
    "ultimate_f4": "+ PDF, Word, Excel &amp; menus",
    "ultimate_f5": "Newsletter &mdash; 10,000 emails / month",
    "ultimate_f6": "Premium support",
    "ultimate_f7": "Email &mdash; 10 inboxes (15 GB each) + 50 aliases",
    "ultimate_cta": "Start Ultimate",
    "enterprise_name": "Enterprise & Agency",
    "enterprise_tagline": "For agencies and special requirements.",
    "enterprise_desc": "Special requirements or system integration? Tell us what you need and we'll tailor a plan.",
    "enterprise_price": "Let's talk",
    "enterprise_price_note": "Custom pricing",
    "enterprise_f1": "Unlimited languages",
    "enterprise_f2": "Unlimited pages",
    "enterprise_f3": "System & API integration",
    "enterprise_f4": "Agency & reseller use",
    "enterprise_f5": "99.99% uptime SLA",
    "enterprise_f6": "Advanced support & onboarding",
    "enterprise_cta": "Contact us",
    "enterprise_subject": "Enterprise & Agency plan enquiry",
    "enterprise_line": "Looking for Enterprise or Agency solutions?",
    "one_month_free": "2 months free",
    "opening": "Opening…",
    "choose_for_site": "Choose a plan for {site}",
    "checkout_error": "Something went wrong starting checkout. Please try again.",
    "pay_by_invoice": "Prefer to pay by invoice?",
    "referral_toggle": "Referral code?",
    "referral_label": "Referral code",
    "referral_placeholder": "e.g. GOURMET",
    "invoice_sent": "Your invoice is on its way by email — everything unlocks as soon as your bank transfer arrives.",
    "domain_example_name": "your-name",
    "grid": {
      "features": {
        "best_for": "Best for",
        "domain": "Domain",
        "text": "Text editing",
        "hosting": "Hosting",
        "voice": "Talk to TOBY",
        "media": "Photos & documents",
        "seo": "Search & AI visibility",
        "pages": "Pages",
        "languages": "Languages",
        "newsletter": "Newsletter",
        "email": "Business email",
        "support": "Support"
      },
      "values": {
        "easy": {
          "best_for": "Online fast — smart from day one",
          "domain": "Your own toby.site web address",
          "text": "Chat with TOBY anytime",
          "hosting": "Fast worldwide hosting included",
          "voice": "Talk to TOBY by voice",
          "media": "Photos &amp; image upload",
          "seo": "Optimized for discovery by Google and AI assistants<br><small>e.g. Google Search+AI, ChatGPT, Gemini, Claude etc.</small>",
          "pages": "Up to 7 pages",
          "languages": "1 language",
          "newsletter": "200 emails / month",
          "email": "—",
          "support": "Self-serve help"
        },
        "business": {
          "best_for": "For everyday business",
          "domain": "Your own domain included<br>{tlds}",
          "text": "Chat with TOBY anytime",
          "hosting": "Fast worldwide hosting included",
          "voice": "Talk to TOBY by voice",
          "media": "Image, PDF, Word &amp; Excel upload",
          "seo": "Optimized for discovery by Google and AI assistants<br><small>e.g. Google Search+AI, ChatGPT, Gemini, Claude etc.</small>",
          "pages": "Up to 15 pages",
          "languages": "Auto-translated into 1 more language",
          "newsletter": "1,000 emails / month",
          "email": "1 email address",
          "support": "Standard support"
        },
        "premium": {
          "best_for": "For businesses that want more",
          "domain": "Your own domain included<br>{tlds}",
          "text": "Chat with TOBY anytime",
          "hosting": "Fast worldwide hosting included",
          "voice": "Talk to TOBY by voice",
          "media": "Image, PDF, Word &amp; Excel upload",
          "seo": "Optimized for discovery by Google and AI assistants<br><small>e.g. Google Search+AI, ChatGPT, Gemini, Claude etc.</small>",
          "pages": "Up to 30 pages",
          "languages": "Auto-translated into 3 more languages",
          "newsletter": "5,000 emails / month",
          "email": "3 email addresses",
          "support": "Standard support"
        }
      }
    }
  },
  "limits": {
    "headline": {
      "block": "Limit reached",
      "warn": "Almost at the limit"
    },
    "see_site": "See your published site",
    "plan_choice": {
      "continue_with": "Continue with {plan}",
      "whats_included": "See what's included",
      "open": "See your plan options"
    },
    "cta": {
      "plans_native": "You can manage your plans on the tobysite website."
    }
  },
  "errors": {
    "not_found": {
      "title": "Page not found",
      "heading": "This page doesn't exist",
      "description": "The page you're looking for can't be found. It may have moved or never existed.",
      "back_home": "Back to my website",
      "back_to_website": "Back to homepage"
    }
  },
  "analytics": {
    "title": "Analytics",
    "subtitle": "How {site} is doing",
    "nav_description": "Page views, popular pages and newsletter sign-ups.",
    "empty": "No page views recorded yet.",
    "empty_period": "No page views in this period.",
    "other": "Other",
    "total": "Total",
    "period": {
      "label": "Time period",
      "last_30_days": "Last 30 days",
      "whole_year": "Whole year {year}"
    },
    "visits": {
      "title": "Page views over time",
      "description": "{count} page views by people. Updated every hour.",
      "series": "People",
      "bots_series": "Bots",
      "empty": "No page views recorded yet. Once your site is published and people open it, you'll see the page views here."
    },
    "pages": {
      "title": "Most-viewed pages",
      "description": "How often each page was opened",
      "home": "Home"
    },
    "countries": {
      "title": "Page views by country",
      "description": "Where your pages were opened from",
      "unknown": "Unknown location"
    },
    "newsletter": {
      "title": "Newsletter subscribers",
      "description": "{count} subscribers in total",
      "series": "Subscribers",
      "empty": "No subscribers yet. When people sign up on your site, their growth shows here."
    }
  },
  "welcome": {
    "title": "Welcome to TOBY",
    "heading": "Welcome!",
    "description": "Tell us your name to finish setting up your account.",
    "description_source": "One quick question before you dive in.",
    "first_name": "First name",
    "first_name_placeholder": "Maria",
    "last_name": "Last name",
    "last_name_placeholder": "Huber",
    "source_question": "How did you find TOBY?",
    "source_friend": "Someone recommended it",
    "source_search": "Google or another search engine",
    "source_ai": "An AI assistant (ChatGPT, Claude, Gemini …)",
    "source_social": "Social media",
    "source_other": "Somewhere else",
    "source_ai_prompt_label": "What did you ask it?",
    "source_ai_prompt_placeholder": "e.g. “I need a simple website for my café”",
    "source_other_detail_placeholder": "Where? (optional)",
    "continue": "Continue",
    "skip": "Skip for now"
  },
  "review_invite": {
    "title": "Your TOBY preview",
    "greeting": "Hello {name}",
    "greeting_outlet": "Hello {name} from {outlet}",
    "intro": "This opens a private copy of a TOBY demo website. Change it by chatting with the assistant or by voice, just as our customers do.",
    "notice_heading": "Please note",
    "notice_expiry": "This is a preview. It ends on {date}, after which your copy is taken offline and deleted.",
    "notice_newsletters": "Sending newsletters to subscribers is switched off.",
    "notice_questions": "Questions? Write to",
    "accept_label": "I've read this and understand it's a time-limited preview.",
    "submit": "Open my preview",
    "unavailable_heading": "This link isn't valid any more",
    "unavailable_body": "Please get in touch and we'll sort it out:"
  },
  "terms_acceptance": {
    "title": "Before you start",
    "heading": "Almost there",
    "description": "A few quick things before you get started.",
    "terms_label": "I accept the {terms}.",
    "terms_link": "Terms of Service",
    "research_label": "TOBY may use my conversations with the assistant to improve TOBY.",
    "research_hint": "You can change this anytime in your settings. Details are in our {privacy}.",
    "marketing_label": "Yes, TOBY may email me tips for my website, product news, and requests for feedback or reviews. I can withdraw this anytime in my settings or via the link in every email.",
    "marketing_hint": "Details are in our {privacy}.",
    "privacy_link": "privacy policy",
    "continue": "Continue",
    "sign_out": "Not now, sign me out"
  },
  "modernize": {
    "form": {
      "title": "Modernize your homepage",
      "subtitle": "Paste the address of the website you'd like to refresh.",
      "url_label": "Your website address",
      "submit": "Modernize"
    },
    "status": {
      "title": "Building your new website",
      "subtitle": "We're turning {url} into a fresh TOBY website. This usually takes a minute or two.",
      "steps": {
        "fetching": "Reading your current website",
        "redesigning": "Designing your new pages",
        "importing_photos": "Bringing over your photos"
      },
      "queued": "Waiting to fetch your homepage…",
      "redesign_hints": {
        "reading": "Reading through your content…",
        "writing": "Writing your new texts…",
        "arranging": "Putting your pages together…"
      },
      "pages_found": "{count, plural, one {1 page} other {# pages}}",
      "images_progress": "{done} of {total}",
      "pages_progress": "{done} of {total}",
      "ready": "Your new website is ready — opening your editor…",
      "stalled": "This is taking longer than usual. You can keep waiting — or try again.",
      "failed": {
        "title": "We couldn't finish your website",
        "body": "Something went wrong along the way. This sometimes happens when a website is temporarily unreachable — trying again usually fixes it.",
        "retry": "Try again",
        "start_over": "Use a different address"
      }
    }
  },
  "report": {
    "title": "Report illegal content",
    "subtitle": "If a website hosted by TOBY shows content you believe is illegal, tell us here. We review every report promptly.",
    "url_label": "Address (URL) of the page",
    "reason_label": "Why do you consider this content illegal?",
    "reason_placeholder": "Describe the content and explain why you believe it is illegal. Be as specific as possible.",
    "name_label": "Your name",
    "email_label": "Your email",
    "email_note": "We use your email only to confirm receipt and to follow up on this report.",
    "good_faith_label": "I am submitting this report in good faith and the information I provided is accurate and complete to the best of my knowledge.",
    "submit": "Submit report",
    "success_title": "Report received",
    "success_body": "Thank you. We emailed you a confirmation and will review the reported content promptly.",
    "another": "Submit another report",
    "alt_channel": "You can also reach us directly at"
  },
  "legal": {
    "hub_title": "Legal",
    "data_processors": {
      "title": "Data Processors",
      "intro": "TOBY shares limited data with the following sub-processors to run the service.",
      "form_messages_note": "Contact-form messages: a message a visitor sends through a customer's contact form is delivered to that customer by email and, on their behalf, also stored encrypted on our platform, so that it is not lost if the email cannot be delivered. We delete it automatically after at most 12 months, and immediately on the customer's instruction.",
      "col_processor": "Processor",
      "col_purpose": "Purpose",
      "col_location": "Location",
      "col_privacy": "Privacy policy",
      "loc_us_eu": "United States / EU",
      "loc_ireland": "Ireland",
      "loc_germany": "Germany",
      "loc_germany_region": "Germany (eu-central-1)",
      "loc_netherlands": "Netherlands",
      "purpose_google": "Sign-in (OAuth), AI assistant, app push notifications, and Android app purchases through Google Play (as seller)",
      "purpose_apple": "Sign in with Apple and push notifications on iOS",
      "purpose_cloudflare": "Hosting, CDN, file storage, bot protection",
      "purpose_stripe": "Payments, subscriptions, billing",
      "purpose_hetzner": "Hosting",
      "purpose_aws": "Newsletter email delivery and encrypted database backups",
      "purpose_openprovider": "Domain registration & email hosting (WHOIS registrant contact, mailboxes)"
    }
  },
  "billing": {
    "invoice": {
      "title": "Pay by invoice",
      "subtitle": "We'll email you an invoice with bank-transfer details. Your plan activates automatically once your payment arrives — bank transfers can take a few days.",
      "company_name": "Company name",
      "street": "Street and number",
      "street2": "Address line 2 (optional)",
      "city": "City",
      "postal_code": "Postal code",
      "country": "Country",
      "country_placeholder": "Select a country",
      "vat_id": "VAT ID (optional)",
      "submit": "Send my invoice"
    },
    "invoice_confirmation": {
      "title": "Your invoice is on its way",
      "body": "We've emailed your invoice with bank-transfer details to {email}.",
      "delay_note": "It can take a few minutes to arrive — please check your spam folder if you don't see it.",
      "unlocks": "Your plan activates automatically once your payment arrives; bank transfers can take a few days.",
      "back": "Back to your website"
    },
    "store": {
      "billed_through": "Billed through {store}",
      "ends": "Ends {date}",
      "manage": "Manage in {store}",
      "site_billed": "This website is paid for through {store}. You can change its plan there."
    },
    "free_month_over": "Your free month is over. Continue with Easy for €12 a month, or delete your website.",
    "delete_site": "Delete website",
    "delete_title": "Delete your website?",
    "delete_body": "Your website goes offline right away. You can't undo this yourself.",
    "delete_confirm": "Yes, delete it",
    "delete_cancel": "Keep my website",
    "deleting": "Deleting…"
  },
  "analytics_opt_out": {
    "title": "This browser no longer counts",
    "body": "TOBY's visitor statistics now ignore everything you do here from this browser. Open this page once in every browser you test from. The setting stays until you clear this site's data in your browser."
  },
  "confirm_email": {
    "title": "Confirm your email address",
    "intro": "The organisation that manages internet domain names requires the owner of every website address to confirm their email address. If you don't, your website is taken offline — so please confirm below.",
    "cta": "Confirm my address",
    "not_yours": "Not your address, or not expecting this? Write to us at",
    "help": "If you're stuck, write to us at",
    "confirmed": {
      "title": "Thank you — that's done",
      "body": "Your email address is confirmed and your website stays online. There's nothing else you need to do."
    },
    "already": {
      "title": "This is already confirmed",
      "body": "Your email address was confirmed earlier, so your website stays online. There's nothing else you need to do."
    },
    "stale": {
      "title": "This link has expired",
      "body": "We sent you a newer email since this one. Please open the most recent message from us and use the link there."
    },
    "invalid": {
      "title": "This link no longer works",
      "body": "It may have expired or been replaced. Please open the most recent message from us and use the link there."
    },
    "unresolved": {
      "title": "We've got it — we're just finishing up",
      "body": "We couldn't reach our domain provider to complete this right away, but nothing more is needed from you. Feel free to try the link again in a few minutes; the reminder email and its deadline still apply either way."
    },
    "throttled": {
      "title": "Too many attempts",
      "body": "Please wait a minute and then try the link in your email again."
    },
    "incomplete": {
      "title": "This link is incomplete",
      "body": "Some of the link seems to be missing. Please open the email again and click the link rather than copying it, or use the most recent message from us."
    }
  },
  "cancel": {
    "title": "Cancel your contract here",
    "subtitle": "You can cancel your TOBY plan here at any time — no login needed. We'll confirm it by email straight away.",
    "kind_label": "How would you like to cancel?",
    "kind_ordinary": "Ordinary (within the notice period)",
    "kind_ordinary_hint": "Your plan ends when the period you have already paid for runs out.",
    "kind_extraordinary": "For cause (extraordinary)",
    "kind_extraordinary_hint": "For an extraordinary cancellation. Tell us the reason and we will come back to you.",
    "reason_label": "What is the important reason?",
    "reason_placeholder": "Describe what happened, as specifically as you can.",
    "name_label": "Your name",
    "email_label": "Your email",
    "email_note": "We send the confirmation of your cancellation to this address.",
    "contract_label": "Your website (optional)",
    "contract_placeholder": "example.com",
    "contract_note": "Helps us find the right contract. Not a substitute for the number above.",
    "end_label": "When should the cancellation take effect?",
    "end_note": "Your plan normally ends when the period you've already paid for runs out.",
    "submit": "Cancel now",
    "alt_channel": "You can also reach us directly at",
    "success_title": "Cancellation received",
    "success_received": "Your cancellation reached us on {datetime}.",
    "success_no_contract": "We could not find a current plan for this email address. The confirmation email we just sent explains what to do next.",
    "success_under_review": "We are looking at your cancellation and will confirm the exact end date shortly.",
    "success_email_note": "We emailed the confirmation to {email}.",
    "success_check_email": "Your cancellation is on file",
    "success_check_email_hint": "We've sent the confirmation, with the exact end date, to the email address on the account. Until that date everything carries on as before — your website stays online and you can keep working on it.",
    "reference_label": "Customer or invoice number",
    "reference_placeholder": "e.g. A1B2C3D4-0001",
    "reference_note": "You'll find it on any invoice from us. Needed if you're not writing from the email address on your account.",
    "account_email_label": "Email address of your TOBY account",
    "account_email_note": "Leave empty if it's the same as above. Helps us find the right contract if you're writing from a different address.",
    "end_earliest": "At the earliest possible date",
    "end_custom": "On a date I choose"
  },
  "referral_landing": {
    "meta_title": "A recommendation for TOBY",
    "meta_description": "A personal recommendation: your website, as easy as sending a message.",
    "headline_named": "{name} recommends TOBY.",
    "headline_anonymous": "A customer recommends TOBY.",
    "subline": "Your website, as easy as sending a message: tell TOBY what should change, and TOBY changes it.",
    "visit_site": "Visit website",
    "how_title": "How it works",
    "how_monthly": "On a monthly plan, you pay for the first month and the second month is free.",
    "how_annual": "On an annual plan, the price of one month comes straight off your first annual invoice.",
    "how_referrer": "The person who recommended TOBY also gets one month free once you have paid.",
    "cta": "See plans",
    "code_line": "Your referral code: {code}"
  },
  "upload_status": {
    "preparing": "Getting your video ready…",
    "video": "Uploading your video…",
    "image": "Uploading your image…",
    "document": "Uploading your document…",
    "finishing": "Almost done…",
    "more": "{count} more",
    "cancel": "Cancel",
    "connection_lost": "The connection dropped. Please try again, and keep TOBY open until it's done."
  }
}
